import { createSelector } from 'reselect';
import { standardTrade, marginTrade } from '../../constants/tradingStyleConstants';
export var tradingStyleSelector = createSelector(function (state) {
  return state.form.tradingStyle;
}, function (tradingStyleForm) {
  if (tradingStyleForm) {
    return tradingStyleForm.values.tradingStyle;
  }
  return standardTrade;
});

// Checks whether a user has margin trading activated in the UI.
export var isMarginActiveSelector = createSelector([tradingStyleSelector], function (tradingStyle) {
  return tradingStyle === marginTrade;
});

// Checks whether the Operator + User has margin capability.
export var isMarginEnabledSelector = createSelector(function (state) {
  return state.user.userInfo;
}, function (state) {
  return state.margin.accountState;
}, function (userInfo, marginAccountState) {
  return !!userInfo.MarginBorrowerEnabled && marginAccountState.accountState.AccountStateStatus === 'Open';
});
export var marginAccountSelector = createSelector(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts.find(function (account) {
    return account.AccountType === 'MarginAsset';
  });
});
export var notMarginAccountsSelector = createSelector(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts.filter(function (account) {
    return account.AccountType !== 'MarginAsset';
  });
});
export var accountIdSelector = createSelector(marginAccountSelector, function (state) {
  return state.user.selectedAccountId;
}, isMarginActiveSelector, function (marginAccount, selectedAccountId, isMarginActive) {
  return isMarginActive ? marginAccount.AccountId : selectedAccountId;
});
export var defaultAccountSelector = createSelector(notMarginAccountsSelector, function (state) {
  return state.user.userInfo.AccountId;
}, function (accounts, defaultAccountId) {
  return accounts.find(function (acct) {
    return acct.AccountId === defaultAccountId;
  });
});
export var marginBaseAssetSelector = createSelector(function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return state.margin.accountState.settings;
}, function (products, settings) {
  if (!settings || !settings.BasedAssetId || !products.length) return {
    Product: 'USD'
  };
  return products.find(function (i) {
    return i.ProductId === settings.BasedAssetId;
  });
});